import { Link } from 'react-router-dom';
import { latestArticles } from '@/mocks/home';

const articleImages: Record<string, string> = {
  'article-ucl': 'https://readdy.ai/api/search-image?query=Professional%20soccer%20match%20dramatic%20lighting%20warm%20golden%20tones%20clean%20background%20editorial%20style%20high%20detail%20cinematic%20composition%20champions%20league%20atmosphere&width=600&height=400&seq=article-ucl&orientation=landscape',
  'article-nba': 'https://readdy.ai/api/search-image?query=Professional%20basketball%20game%20dramatic%20arena%20lighting%20warm%20golden%20tones%20clean%20background%20editorial%20style%20high%20detail%20NBA%20atmosphere&width=600&height=400&seq=article-nba&orientation=landscape',
  'article-lck': 'https://readdy.ai/api/search-image?query=Professional%20esports%20arena%20dramatic%20stage%20lighting%20warm%20golden%20tones%20gaming%20competition%20editorial%20style%20high%20detail%20cinematic%20composition&width=600&height=400&seq=article-lck&orientation=landscape',
  'article-tennis': 'https://readdy.ai/api/search-image?query=Professional%20tennis%20match%20dramatic%20court%20lighting%20warm%20golden%20tones%20clean%20background%20editorial%20style%20high%20detail%20grand%20slam%20atmosphere&width=600&height=400&seq=article-tennis&orientation=landscape',
};

export default function LatestArticles() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-end justify-between mb-10">
            <div>
              <span className="text-primary-600 text-sm font-semibold tracking-wide">体育资讯</span>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mt-2">
                最新文章
              </h2>
              <p className="text-foreground-500 text-sm mt-2">深度赛事分析 · 专业体育视角</p>
            </div>
            <Link
              to="/category/news"
              className="hidden sm:flex items-center gap-1 text-primary-600 hover:text-primary-700 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors"
            >
              全部文章 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {latestArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-all duration-200 cursor-pointer"
              >
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={articleImages[article.imageSeq] || articleImages['article-ucl']}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-0.5 rounded-full bg-accent-500/90 text-white text-xs font-medium">
                      {article.category}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="font-semibold text-foreground-900 text-sm leading-snug mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center justify-between text-xs text-foreground-400">
                    <span><i className="ri-calendar-line mr-1"></i>{article.date}</span>
                    <span><i className="ri-time-line mr-1"></i>{article.readTime}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div className="mt-8 text-center sm:hidden">
            <Link
              to="/category/news"
              className="inline-flex items-center gap-1 text-primary-600 hover:text-primary-700 text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              全部文章 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}